import { render, staticRenderFns } from "./SectionHeadline.vue?vue&type=template&id=7cb18edc&scoped=true&"
import script from "./SectionHeadline.vue?vue&type=script&lang=js&"
export * from "./SectionHeadline.vue?vue&type=script&lang=js&"
import style0 from "./SectionHeadline.vue?vue&type=style&index=0&id=7cb18edc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb18edc",
  null
  
)

export default component.exports